/**
 * How long an unanswered call rings before it is given up on.
 *
 * Every ring window must agree on this or the call ends up in a half-state:
 * the phone's CallKit UI stops ringing at its own duration while the call node
 * is still CALLING, or the caller sits on "Calling..." long after the callee's
 * device has given up. Change it here and in CallkitService.showIncoming's
 * `duration` (the native UI takes milliseconds too).
 */
export const RING_TIMEOUT_MS = 45000;
